
import Phaser from 'phaser';
import { DebugLog } from './DebugLog';

function onceComplete(scene: Phaser.Scene): Promise<void> {
  return new Promise((resolve, reject) => {
    scene.load.once(Phaser.Loader.Events.COMPLETE, () => resolve());
    scene.load.once('loaderror', (file: Phaser.Loader.File) => {
      reject(new Error(`Asset load failed: ${file.key}`));
    });
    scene.load.start();
  });
}

export async function ensureImage(scene: Phaser.Scene, key: string, path: string): Promise<void> {
  if (scene.textures.exists(key)) {
    DebugLog.info('AssetLoader', `texture cache hit ${key}`);
    return;
  }
  DebugLog.info('AssetLoader', `load image ${key}`, { path });
  scene.load.image(key, path);
  await onceComplete(scene);
  DebugLog.info('AssetLoader', `image ready ${key}`);
}
